document.addEventListener("DOMContentLoaded", function () {

    const slides = document.querySelectorAll(".video-slide");
    const dots = document.querySelectorAll(".dot");
    const prevBtn = document.querySelector(".slider-arrow.prev");
    const nextBtn = document.querySelector(".slider-arrow.next");

    if (!slides.length) return;

    let current = 0;
    let slider;

    function playCurrentVideo() {
        slides.forEach(slide => {
            const video = slide.querySelector("video");

            if (video) {
                video.pause();
                video.currentTime = 0;
            }
        });

        const activeVideo = slides[current].querySelector("video");

        if (activeVideo) {
            activeVideo.play().catch(() => {});
        }
    }

    function showSlide(index) {
        const currentSlide = document.querySelector(".current-slide");

if(currentSlide){

    currentSlide.textContent = String(index + 1).padStart(2,"0");

}

        slides.forEach(slide => slide.classList.remove("active"));
        dots.forEach(dot => dot.classList.remove("active"));

        current = index;

        slides[current].classList.add("active");

        if (dots[current]) {
            dots[current].classList.add("active");
        }

        playCurrentVideo();
    }

    function nextSlide() {

        current++;

        if (current >= slides.length) {
            current = 0;
        }

        showSlide(current);
    }

    function prevSlide() {

        current--;

        if (current < 0) {
            current = slides.length - 1;
        }

        showSlide(current);
    }

    function startSlider() {

        slider = setInterval(nextSlide, 6000);

    }

    function stopSlider() {

        clearInterval(slider);

    }

    showSlide(0);

    startSlider();

    nextBtn?.addEventListener("click", function () {

        stopSlider();

        nextSlide();

        startSlider();

    });

    prevBtn?.addEventListener("click", function () {

        stopSlider();

        prevSlide();

        startSlider();

    });

    dots.forEach((dot, index) => {

        dot.addEventListener("click", function () {

            stopSlider();

            showSlide(index);

            startSlider();

        });

    });
    const sliderContainer = document.querySelector(".video-slideshow");

sliderContainer?.addEventListener("mouseenter", stopSlider);

sliderContainer?.addEventListener("mouseleave", startSlider);

});